import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  LanguageSelect,
  LocaleCode,
  useAccountSettings,
} from '@/entities/account';
import { useLocale } from '@/shared/stores/accountStore';
import { SelectChangeEvent } from '@/shared/ui';
import { dayjs } from '@/shared/utils/dayjs';

import { useChangeLanguage } from '../model/useChangeLanguage';

export const LanguageSwitcher = ({ isAuthPage }: { isAuthPage?: boolean }) => {
  const { ready, i18n } = useTranslation();
  const localeStore = useLocale();
  const { accountSettings } = useAccountSettings(!isAuthPage);

  const systemLocale = accountSettings?.locale;

  useEffect(() => {
    if (systemLocale) {
      i18n.changeLanguage(systemLocale);
      dayjs.locale(systemLocale);
    }
  }, [systemLocale, i18n]);

  const { changeLanguage } = useChangeLanguage(isAuthPage);

  const changeLocale = async (newLocale: LocaleCode) => {
    await changeLanguage(newLocale);
  };

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const newLocale = event.target.value as LocaleCode;
    changeLocale(newLocale);
  };

  if (!ready || !localeStore) return null;

  return (
    <LanguageSelect
      value={systemLocale ?? localeStore}
      onChange={handleChange}
    />
  );
};
